
import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import Dropdown from '@/components/Dropdown.vue'

@Component<FilterBarTVMenu>({
    components: { Dropdown },
})
export default class FilterBarTVMenu extends Vue {
    public show = false
}
